import { z } from 'zod';

export const jobChangeProcessSchema = z.object({
  result: z.string().optional(),
  stepRange: z.array(z.string()).optional(),
  dateRange: z
    .object({
      start: z.date().optional(),
      end: z.date().optional(),
    })
    .optional(),
  scheduleStatuses: z.array(z.string()),
  keyword: z.string().optional(),
});

export type JobChangeProcessSchema = z.infer<typeof jobChangeProcessSchema>;
